import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { orNotFound } from "../components/prenoms/load";
import { NamePage, nameHead } from "../components/prenoms/name-page";
import { namesApi } from "../lib/api";
import { seo } from "../lib/head";

export const Route = createFileRoute("/prenoms/$slug")({
  staticData: { ssr: true },
  // A birth year from the finder personalises the page; anything else is ignored.
  validateSearch: z.object({
    annee: z.coerce.number().int().min(1900).max(2025).optional().catch(undefined),
  }),
  loader: ({ context, params }) =>
    orNotFound(() =>
      context.queryClient.query({
        queryKey: ["prenom", params.slug],
        queryFn: () => namesApi.get(params.slug),
        staleTime: "static",
      }),
    ),
  head: ({ loaderData }) =>
    loaderData ? seo(nameHead(loaderData.data, loaderData.overallRank)) : {},
  component: Page,
});
function Page() {
  const { data, related, overallRank } = Route.useLoaderData();
  const { annee } = Route.useSearch();
  return <NamePage data={data} related={related} overallRank={overallRank} year={annee} />;
}
